import gxv33x0_bg0 from '@/assets/images/wallpapers/gxv33x0/wallpaper_bg0.jpg';
import gxv33x0_bg1 from '@/assets/images/wallpapers/gxv33x0/wallpaper_bg1.jpg';
import gxv33x0_bg2 from '@/assets/images/wallpapers/gxv33x0/wallpaper_bg2.jpg';
import gxv33x0_bg3 from '@/assets/images/wallpapers/gxv33x0/wallpaper_bg3.jpg';
import gxv33x0_bg4 from '@/assets/images/wallpapers/gxv33x0/wallpaper_bg4.jpg';
import gxv33x0_bg5 from '@/assets/images/wallpapers/gxv33x0/wallpaper_bg5.jpg';
import gxv33x0_bg6 from '@/assets/images/wallpapers/gxv33x0/wallpaper_bg6.jpg';
import gxv33x0_bg7 from '@/assets/images/wallpapers/gxv33x0/wallpaper_bg7.jpg';

import gxv34x0_bg0 from '@/assets/images/wallpapers/gxv34x0/wallpaper_bg0.png';
import gxv34x0_bg1 from '@/assets/images/wallpapers/gxv34x0/wallpaper_bg1.png';
import gxv34x0_bg2 from '@/assets/images/wallpapers/gxv34x0/wallpaper_bg2.png';
import gxv34x0_bg3 from '@/assets/images/wallpapers/gxv34x0/wallpaper_bg3.png';
import gxv34x0_bg4 from '@/assets/images/wallpapers/gxv34x0/wallpaper_bg4.png';
import gxv34x0_bg5 from '@/assets/images/wallpapers/gxv34x0/wallpaper_bg5.png';
import gxv34x0_bg6 from '@/assets/images/wallpapers/gxv34x0/wallpaper_bg6.png';

import gxv3470_bg0 from '@/assets/images/wallpapers/gxv3470/wallpaper_bg0.png';
import gxv3470_bg1 from '@/assets/images/wallpapers/gxv3470/wallpaper_bg1.png';
import gxv3470_bg2 from '@/assets/images/wallpapers/gxv3470/wallpaper_bg2.png';
import gxv3470_bg3 from '@/assets/images/wallpapers/gxv3470/wallpaper_bg3.png';
import gxv3470_bg4 from '@/assets/images/wallpapers/gxv3470/wallpaper_bg4.png';
import gxv3470_bg5 from '@/assets/images/wallpapers/gxv3470/wallpaper_bg5.png';
import gxv3470_bg6 from '@/assets/images/wallpapers/gxv3470/wallpaper_bg6.png';

const GXV33X0_BG_LIST = [
  gxv33x0_bg0,
  gxv33x0_bg1,
  gxv33x0_bg2,
  gxv33x0_bg3,
  gxv33x0_bg4,
  gxv33x0_bg5,
  gxv33x0_bg6,
  gxv33x0_bg7,
];

const GXV34X0_BG_LIST = [
  gxv34x0_bg0,
  gxv34x0_bg1,
  gxv34x0_bg2,
  gxv34x0_bg3,
  gxv34x0_bg4,
  gxv34x0_bg5,
  gxv34x0_bg6,
];

// GXV3470竖屏壁纸
const GXV3470_BG_LIST = [
  gxv3470_bg0,
  gxv3470_bg1,
  gxv3470_bg2,
  gxv3470_bg3,
  gxv3470_bg4,
  gxv3470_bg5,
  gxv3470_bg6,
];

export const bgList = {
  gxv3350: GXV33X0_BG_LIST,
  gxv3370: GXV33X0_BG_LIST,
  gxv3380: GXV33X0_BG_LIST,
  gxv3450: GXV34X0_BG_LIST,
  gxv3470: GXV3470_BG_LIST,
  gxv3480: GXV34X0_BG_LIST,
  gac2570: GXV33X0_BG_LIST,
};
